import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { WizzardEffects } from './wizzard.effects';
import { wizzardReducer } from './wizzard.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('wizzard', wizzardReducer), EffectsModule.forFeature([WizzardEffects])],
    exports: [],
    providers: [],
})
export class WizzardStateModule {}
